// extracted by mini-css-extract-plugin
export var productImage = "_jo-1";
export var viewLink = "_jo-2";
export var wishlistItem = "_jo-0";